// @flow
import styled from 'styled-components'
import { Layout, Tabs, Row } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 0px;
  min-height: 280px;
  
  .ant-card-type-inner .ant-card-body{
     padding: 10px 12px;
  }
  
  .ant-collapse>.ant-collapse-item>.ant-collapse-header{
      padding: 5px 0 5px 40px;
  }
  
  .ant-collapse>.ant-collapse-item>.ant-collapse-header .arrow{
      line-height: 36px;
  }

  .price-line{
       border-bottom: solid 1px #eee;
       margin-bottom: 10px;
       padding-bottom: 10px;
  }
  
  .remove-sce{
    margin-top: 5px;
    margin-right: 10px;
    float: right;
  }
  i.anticon.anticon-play-circle, i.anticon.anticon-pause-circle {
    line-height: 40px;
    padding-left: 12px;
  }
  .download-row {
    text-align: right;
    .ant-btn {
      margin-top: -30px;
    }
  }
`

export const StyledTabs = styled(Tabs)`
  padding: 0;
  & .ant-tabs-nav-container {
    padding: 24px
  }
  & .ant-tabs-content {
     padding: 0
  }
  & .loading {
    padding-left: 30px; 
  }
  & .ant-timeline { 
    padding: 30px;
  }
`
export const StyledRow = styled(Row)`
  padding: 10px 25px;
`




// WEBPACK FOOTER //
// ./src/components/view-trades/style.js